/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import {
    EReportsConstructorSource,
    CONSTRUCTOR_REPORT_TYPES,
    ETemplateRenameField,
    EConstructorReportsAdditional,
    EConstructorReportsNew,
    EConstructorItem,
} from './constants';

export interface IReportsConstructorLocationData {
    source?: keyof typeof EReportsConstructorSource;
    bisAccountId?: number;
}

export interface ICurrentRowItem {
    rowId: string;
    rowItemId: number;
    rowType: EConstructorItem;
    selectedItem: IReportsConstructorSelectedItem;
}

export interface IReportsConstructorSlice {
    selectedItem: IReportsConstructorSelectedItem | null;
    currentRowItem: ICurrentRowItem | null;
    templatesData: {
        elements: IConstructorTemplate[];
        count: number;
        page: number;
    };
}

export interface IReportsConstructorSelectedItem {
    id: number;
    reportType: keyof typeof CONSTRUCTOR_REPORT_TYPES;
    itemType: EConstructorItem;
}

export interface IConstructorReport {
    id: number;
    title: string;
    description: string;
    type: keyof typeof CONSTRUCTOR_REPORT_TYPES;
    icon?: string;
    schedule?: boolean;
}

export interface IConstructorTemplate {
    id: number;
    reportId: number;
    name: string;
    type: keyof typeof EConstructorReportsNew;
    createDate: string;
    schedule?: boolean;
}

export interface IReportsConstructorMetaQuery {
    bisAccountId?: number;
    source?: keyof typeof EReportsConstructorSource;
}

export interface IReportsConstructorMetaResponse {
    additionalReports: IAdditionalReportMeta[];
    subscribersCount: number;
}

export interface IAdditionalReportMeta {
    id: number;
    type: keyof typeof EConstructorReportsAdditional;
    schedule: boolean;
}

export interface INewReportsData {
    id: number;
    type: keyof typeof EConstructorReportsNew;
    icon?: string;
}

export interface IReportsConstructorTemplateDataResponse {
    elements: IConstructorTemplate[];
    count: number;
}

export type TTemplateId = number & { readonly brand: unique symbol };

export function TemplateId(id: number) {
    return id as TTemplateId;
}

export type TReportId = number & { readonly brand: unique symbol };

export function ReportId(id: number) {
    return id as TReportId;
}

export interface ITemplateRenameForm {
    [ETemplateRenameField.name]: string;
}

export interface ITemplateRenameUpdateRequest {
    [ETemplateRenameField.name]: string;
    templateId: TTemplateId;
}

export interface ITemplateRemoveRequest {
    templateId: TTemplateId;
}
